exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-select-tree .el-select-dropdown__item{height:unset!important;line-height:unset!important;background:transparent!important}.model-select-tree .el-tree-node__label{color:#000!important}", ""]);

// exports
